module.exports = __webpack_public_path__ + "img/dmfh_icon.7e14a7aa.png";